$.extend({
    createElement : function (elementName) {
        return $(document.createElement(elementName));
    }
});

function kombinaceDruhuDefiniceDuplikovat(element) {
    var elDefinice = $(element).parents('.kombinaceDruhu-definice'),
        elKombinace = elDefinice.parents('.kombinaceDruhu-kombinace'),
        nova = elDefinice.clone();

    nova.find('input[type="hidden"]').remove();
    nova.appendTo(elKombinace);
    kombinaceDruhuDefinicePreindexovat(elKombinace);

    return false;
}

function kombinaceDruhuDefinicePreindexovat(elBlok) {
    $(elBlok).find('.kombinaceDruhu-definice').each(function(indexDefinice, elDefinice) {
        indexDefinice++;
        $(elDefinice).attr('data-definice', indexDefinice);
        $(elDefinice).find('label, input, textarea, select, div.box-header, div.form-group').each(function (b, element) {
            if (element.getAttribute('name') !== null) {
                element.name = element.name.replace(/\[(\d+)\]\[body/, '[' + indexDefinice + '][body');
                element.name = element.name.replace(/\[(\d+)\]\[bonus/, '[' + indexDefinice + '][bonus');
                element.name = element.name.replace(/\[(\d+)\]\[castka/, '[' + indexDefinice + '][castka');
                element.name = element.name.replace(/\[(\d+)\]\[druh/, '[' + indexDefinice + '][druh');
                element.name = element.name.replace(/\[(\d+)\]\[duvod/, '[' + indexDefinice + '][duvod');
                element.name = element.name.replace(/\[(\d+)\]\[heslo/, '[' + indexDefinice + '][heslo');
                element.name = element.name.replace(/\[(\d+)\]\[idBalicek/, '[' + indexDefinice + '][idBalicek');
                element.name = element.name.replace(/\[(\d+)\]\[idSazba/, '[' + indexDefinice + '][idSazba');
                element.name = element.name.replace(/\[(\d+)\]\[identifikator/, '[' + indexDefinice + '][identifikator');
                element.name = element.name.replace(/\[(\d+)\]\[identifikatoryNelzeKombinovat/, '[' + indexDefinice + '][identifikatoryNelzeKombinovat');
                element.name = element.name.replace(/\[(\d+)\]\[kod/, '[' + indexDefinice + '][kod');
                element.name = element.name.replace(/\[(\d+)\]\[koeficient/, '[' + indexDefinice + '][koeficient');
                element.name = element.name.replace(/\[(\d+)\]\[krok/, '[' + indexDefinice + '][krok');
                element.name = element.name.replace(/\[(\d+)\]\[maximum/, '[' + indexDefinice + '][maximum');
                element.name = element.name.replace(/\[(\d+)\]\[nazev/, '[' + indexDefinice + '][nazev');
                element.name = element.name.replace(/\[(\d+)\]\[nezobrazovat/, '[' + indexDefinice + '][nezobrazovat');
                element.name = element.name.replace(/\[(\d+)\]\[odkazText/, '[' + indexDefinice + '][odkazText');
                element.name = element.name.replace(/\[(\d+)\]\[odkazUrl/, '[' + indexDefinice + '][odkazUrl');
                element.name = element.name.replace(/\[(\d+)\]\[popis/, '[' + indexDefinice + '][popis');
                element.name = element.name.replace(/\[(\d+)\]\[pricist/, '[' + indexDefinice + '][pricist');
                element.name = element.name.replace(/\[(\d+)\]\[procent/, '[' + indexDefinice + '][procent');
                element.name = element.name.replace(/\[(\d+)\]\[sazba/, '[' + indexDefinice + '][sazba');
                element.name = element.name.replace(/\[(\d+)\]\[skupina/, '[' + indexDefinice + '][skupina');
                element.name = element.name.replace(/\[(\d+)\]\[skupiny/, '[' + indexDefinice + '][skupiny');
                element.name = element.name.replace(/\[(\d+)\]\[sleva/, '[' + indexDefinice + '][sleva');
                element.name = element.name.replace(/\[(\d+)\]\[vychoziStav/, '[' + indexDefinice + '][vychoziStav');
            }

            if (element.getAttribute('id') !== null) {
                element.id = element.id.replace(/(\d+)-body/, indexDefinice + '-body');
                element.id = element.id.replace(/(\d+)-bonus/, indexDefinice + '-bonus');
                element.id = element.id.replace(/(\d+)-castka/, indexDefinice + '-castka');
                element.id = element.id.replace(/(\d+)-druh/, indexDefinice + '-druh');
                element.id = element.id.replace(/(\d+)-duvod/, indexDefinice + '-duvod');
                element.id = element.id.replace(/(\d+)-heslo/, indexDefinice + '-heslo');
                element.id = element.id.replace(/(\d+)-hlavicka/, indexDefinice + '-hlavicka');
                element.id = element.id.replace(/(\d+)-idBalicek/, indexDefinice + '-idBalicek');
                element.id = element.id.replace(/(\d+)-idSazba/, indexDefinice + '-idSazba');
                element.id = element.id.replace(/(\d+)-identifikator/, indexDefinice + '-identifikator');
                element.id = element.id.replace(/(\d+)-identifikatoryNelzeKombinovat/, indexDefinice + '-identifikatoryNelzeKombinovat');
                element.id = element.id.replace(/(\d+)-kod/, indexDefinice + '-kod');
                element.id = element.id.replace(/(\d+)-koeficient/, indexDefinice + '-koeficient');
                element.id = element.id.replace(/(\d+)-krok/, indexDefinice + '-krok');
                element.id = element.id.replace(/(\d+)-maximum/, indexDefinice + '-maximum');
                element.id = element.id.replace(/(\d+)-nazev/, indexDefinice + '-nazev');
                element.id = element.id.replace(/(\d+)-nezobrazovat/, indexDefinice + '-nezobrazovat');
                element.id = element.id.replace(/(\d+)-odkazText/, indexDefinice + '-odkazText');
                element.id = element.id.replace(/(\d+)-odkazUrl/, indexDefinice + '-odkazUrl');
                element.id = element.id.replace(/(\d+)-popis/, indexDefinice + '-popis');
                element.id = element.id.replace(/(\d+)-pricist/, indexDefinice + '-pricist');
                element.id = element.id.replace(/(\d+)-procent/, indexDefinice + '-procent');
                element.id = element.id.replace(/(\d+)-sazba/, indexDefinice + '-sazba');
                element.id = element.id.replace(/(\d+)-skupina/, indexDefinice + '-skupina');
                element.id = element.id.replace(/(\d+)-skupiny/, indexDefinice + '-skupiny');
                element.id = element.id.replace(/(\d+)-sleva/, indexDefinice + '-sleva');
                element.id = element.id.replace(/(\d+)-vychoziStav/, indexDefinice + '-vychoziStav');
            }

            if (element.getAttribute('for') !== null) {
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-body/, indexDefinice + '-body'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-bonus/, indexDefinice + '-bonus'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-castka/, indexDefinice + '-castka'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-druh/, indexDefinice + '-druh'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-duvod/, indexDefinice + '-duvod'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-heslo/, indexDefinice + '-heslo'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-idBalicek/, indexDefinice + '-idBalicek'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-idSazba/, indexDefinice + '-idSazba'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-identifikator/, indexDefinice + '-identifikator'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-identifikatoryNelzeKombinovat/, indexDefinice + '-identifikatoryNelzeKombinovat'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-kod/, indexDefinice + '-kod'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-koeficient/, indexDefinice + '-koeficient'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-krok/, indexDefinice + '-krok'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-maximum/, indexDefinice + '-maximum'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-nazev/, indexDefinice + '-nazev'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-nezobrazovat/, indexDefinice + '-nezobrazovat'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-odkazText/, indexDefinice + '-odkazText'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-odkazUrl/, indexDefinice + '-odkazUrl'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-popis/, indexDefinice + '-popis'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-pricist/, indexDefinice + '-pricist'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-procent/, indexDefinice + '-procent'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-sazba/, indexDefinice + '-sazba'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-skupina/, indexDefinice + '-skupina'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-skupiny/, indexDefinice + '-skupiny'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-sleva/, indexDefinice + '-sleva'));
                element.setAttribute('for', element.getAttribute('for').replace(/(\d+)-vychoziStav/, indexDefinice + '-vychoziStav'));
            }
        });
    });
}

function kombinaceDruhuDefinicePridat(element) {
    var elBlok = $(element).parents('.kombinaceDruhu-b3'),
        elKombinace = $(element).parents('.kombinaceDruhu-b3').find('.kombinaceDruhu-kombinace'),
        prefix = $(elBlok).data('prefix'),
        indexDefinice = $(elBlok).find('.kombinaceDruhu-definice').length + 1,

        divBox = $(document.createElement('div'))
            .attr('class', 'box box-primary kombinaceDruhu-definice')
            .attr('data-definice', indexDefinice),

        divBoxHeader = $(document.createElement('div'))
            .attr('class', 'box-header with-border')
            .attr('id',  prefix + '-' + indexDefinice + '-hlavicka'),

        divBoxBody = $(document.createElement('div'))
            .attr('class', 'box-body'),

        divBoxFooter = $(document.createElement('div'))
            .attr('class', 'box-footer'),

        pPridatSkupinu = $(document.createElement('p'))
            .attr('class', 'margin-top-5 margin-bottom-5 text-center'),

        hlavicka = kombinaceDruhuDefiniceHlavicka(divBoxHeader, prefix, indexDefinice),

        table = $(document.createElement('table'))
            .attr('class', 'table table-bordered table-striped kombinaceDruhu-skupina')
            .attr('data-skupina', 1),

        thead = $(document.createElement('thead')),
        theadTr = $(document.createElement('tr')),
        tbody = $(document.createElement('tbody')),
        tfoot = $(document.createElement('tfoot')),
        tfootTr = $(document.createElement('tr')),

        theadThDruh = $(document.createElement('th')).html('Druh').attr('class', 'width-25'),
        theadThHodnota = $(document.createElement('th')).html('Hodnota').attr('class', 'width-40'),
        theadThOd = $(document.createElement('th')).html('Od').attr('class', 'width-10'),
        theadThDo = $(document.createElement('th')).html('Do').attr('class', 'width-10'),
        theadThPresne = $(document.createElement('th')).html('Přesně').attr('class', 'width-10'),
        theadThSmazat = $(document.createElement('th')).attr('class', 'width-5'),
        tfootTdLeva = $(document.createElement('td')).attr('colspan', '2'),
        tfootTdPrava = $(document.createElement('td')).attr('colspan', '4').attr('class', 'text-right'),

        buttonPridatPodminku = $(document.createElement('button'))
            .attr('class', 'kombinaceDruhu-podminka-pridat btn btn-xs btn-primary'),

        buttonPridatPodminkuIcon = $(document.createElement('i'))
            .attr('class', 'fas fa-plus fa-fw'),

        buttonPridatSkupinu = $(document.createElement('button'))
            .attr('class', 'kombinaceDruhu-skupina-pridat btn btn-xs btn-primary'),

        buttonPridatSkupinuIcon = $(document.createElement('i'))
            .attr('class', 'fas fa-plus fa-fw'),

        buttonSmazatSkupinu = $(document.createElement('button'))
            .attr('class', 'kombinaceDruhu-skupina-smazat btn btn-xs btn-danger'),

        buttonSmazatSkupinuIcon = $(document.createElement('i'))
            .attr('class', 'fas fa-trash fa-fw');

    theadTr.append(theadThDruh);
    theadTr.append(theadThHodnota);
    theadTr.append(theadThOd);
    theadTr.append(theadThDo);
    theadTr.append(theadThPresne);
    theadTr.append(theadThSmazat);

    thead.append(theadTr);

    buttonPridatPodminku
        .append(buttonPridatPodminkuIcon)
        .append(' Přidat podmínku');
    buttonPridatSkupinu
        .append(buttonPridatSkupinuIcon)
        .append(' Přidat skupinu podmínek');
    buttonSmazatSkupinu
        .append(buttonSmazatSkupinuIcon)
        .append(' Smazat skupinu podmínek');

    tfootTdLeva.append(buttonPridatPodminku);
    tfootTdPrava.append(buttonSmazatSkupinu);

    tfootTr.append(tfootTdLeva);
    tfootTr.append(tfootTdPrava);

    tfoot.append(tfootTr);

    table.append(thead);
    table.append(tbody);
    table.append(tfoot);

    pPridatSkupinu.append(buttonPridatSkupinu);

    var buttonDuplikovat = $(document.createElement('button'))
        .attr('class', 'kombinaceDruhu-definice-duplikovat btn btn-xs btn-primary'),

        buttonDuplikovatIcon = $(document.createElement('i'))
        .attr('class', 'fas fa-copy fa-fw'),

        buttonSmazat = $(document.createElement('button'))
        .attr('class', 'kombinaceDruhu-definice-smazat btn btn-xs btn-primary'),

        buttonSmazatIcon = $(document.createElement('i'))
        .attr('class', 'fas fa-trash fa-fw'),

        divPatickaRow = $(document.createElement('div'))
        .attr('class', 'row'),

        divPatickaCol = $(document.createElement('div'))
        .attr('class', 'col-sm-12 text-right');

    if ('balickyDopPodminky' !== prefix && 'prirazkySrazky' !== prefix) {
        buttonDuplikovat
            .append(buttonDuplikovatIcon)
            .append(' Duplikovat definici');
        buttonSmazat
            .append(buttonSmazatIcon)
            .append(' Smazat definici');

        divPatickaCol.append(buttonDuplikovat);
        divPatickaCol.append(' ');
        divPatickaCol.append(buttonSmazat);
        divPatickaRow.append(divPatickaCol);
        divBoxFooter.append(divPatickaRow);
    }

    if ('balickyDopPodminky' !== prefix && 'prirazkySrazky' !== prefix) {
        divBoxHeader.append(hlavicka);
        divBox.append(divBoxHeader);
    }

    divBoxBody.append(table);
    divBoxBody.append(pPridatSkupinu);

    divBox.append(divBoxBody);
    divBox.append(divBoxFooter);

    $(elKombinace).append(divBox);

    return false;
}

function kombinaceDruhuDefiniceSmazat(element) {
    var elDiv = $(element).parent(),
        elDefinice = $(elDiv).parents('.kombinaceDruhu-definice'),
        elBlok = $(elDiv).parents('.kombinaceDruhu-b3').find('.kombinaceDruhu-kombinace'),
        elKombinace = $(elBlok).find('.kombinaceDruhu-kombinace'),
        elDefiniceId = $(elDiv).find(':hidden'),
        prefix = $(element).parents('.kombinaceDruhu-b3').data('prefix');

    if ($(elDefiniceId).length > 0) {
        var el = $.createElement('input')
            .attr('type', 'hidden')
            .attr('name', prefix + '-smazaneDefinice[]')
            .val($(elDefiniceId).val());

        $('#' + prefix).append(el);
    }

    $(elDefinice).remove();

    kombinaceDruhuDefinicePreindexovat(elKombinace);

    return false;
}

function kombinaceDruhuPodminkaNactiHodnoty(elementName, idDruh) {
    var element = $('#' + elementName),
        prefix = element.parents('div.kombinaceDruhu-b3').data('prefix'),
        elementDataHodnoty = $('#' + prefix + '-data-hodnoty-' + idDruh);

    element.children().remove();

    if (elementDataHodnoty.children().length >= 1) {
        element.html(elementDataHodnoty.html());

        element.removeClass('hidden');
        $('#' + elementName.replace('idHodnota', 'od')).addClass('hidden').val('');
        $('#' + elementName.replace('idHodnota', 'do')).addClass('hidden').val('');
        $('#' + elementName.replace('idHodnota', 'presne')).addClass('hidden').val('');
    } else {
        element.addClass('hidden');
        $('#' + elementName.replace('idHodnota', 'od')).removeClass('hidden');
        $('#' + elementName.replace('idHodnota', 'do')).removeClass('hidden');
        $('#' + elementName.replace('idHodnota', 'presne')).removeClass('hidden');
    }

    if (idDruh === '' || idDruh === 0) {
        element.addClass('hidden');
        $('#' + elementName.replace('idHodnota', 'od')).addClass('hidden');
        $('#' + elementName.replace('idHodnota', 'do')).addClass('hidden');
        $('#' + elementName.replace('idHodnota', 'presne')).addClass('hidden');
    }
}

function kombinaceDruhuPodminkaPreindexovat(elTabulka) {
    $(elTabulka).find('tbody > tr').each(function (indexPodminka, elTr) {
        indexPodminka++;
        $(elTr).attr('data-podminka', indexPodminka);
        $(elTr).find('input, textarea, select').each(function (b, element) {
            if (element.getAttribute('name') != null) {
                element.name = element.name.replace(/podminky\]\[(\d+)\]/, 'podminky][' + indexPodminka + ']');
            }

            if (element.getAttribute('id') != null) {
                element.id = element.id.replace(/-podminky-(\d+)-/, '-podminky-' + indexPodminka + '-');
            }
        });
    });
}

function kombinaceDruhuPodminkaPridat(element) {
    var elSkupina = $(element).parents('.kombinaceDruhu-skupina'),
        indexDefinice = $(element).parents('.kombinaceDruhu-definice').data('definice'),
        indexSkupina = $(element).parents('.kombinaceDruhu-skupina').data('skupina'),
        indexPodminka = $(elSkupina).find('tbody > tr').length + 1,
        prefix = $(element).parents('.kombinaceDruhu-b3').data('prefix'),
        onkeydown = "return keyPress(this.id, event),",

        tr = $(document.createElement('tr'))
                 .attr('class', 'kombinaceDruhu-podminka')
                 .attr('data-podminka', indexPodminka),

        td1 = $(document.createElement('td')),
        td2 = $(document.createElement('td')),
        td3 = $(document.createElement('td')),
        td4 = $(document.createElement('td')),
        td5 = $(document.createElement('td')),
        td6 = $(document.createElement('td'))
            .attr('class', 'text-center'),

        selectIdDruh = $(document.createElement("select"))
            .attr('id', prefix + '-' + indexDefinice + '-skupiny-' + indexSkupina + '-podminky-' + indexPodminka + '-idDruh')
            .attr('name', prefix + '[' + indexDefinice + '][skupiny][' + indexSkupina + '][podminky][' + indexPodminka + '][idDruh]')
            .attr('class', 'form-control input-sm idDruh')
            .html($('#' + prefix + '-data-druhy').html()),

        selectIdHodnota = $(document.createElement("select"))
            .attr('id', prefix + '-' + indexDefinice + '-skupiny-' + indexSkupina + '-podminky-' + indexPodminka + '-idHodnota')
            .attr('name', prefix + '[' + indexDefinice + '][skupiny][' + indexSkupina + '][podminky][' + indexPodminka + '][idHodnota]')
            .attr('class', 'form-control input-sm hidden'),

        inputOd = $(document.createElement("input"))
            .attr('type', 'text')
            .attr('id', prefix + '-' + indexDefinice + '-skupiny-' + indexSkupina + '-podminky-' + indexPodminka + '-od')
            .attr('name', prefix + '[' + indexDefinice + '][skupiny][' + indexSkupina + '][podminky][' + indexPodminka + '][od]')
            .attr('class', 'form-control input-sm text-right hidden')
            .attr('size', 4)
            .attr('onkeydown', onkeydown),

        inputDo = $(document.createElement("input"))
            .attr('type', 'text')
            .attr('id', prefix + '-' + indexDefinice + '-skupiny-' + indexSkupina + '-podminky-' + indexPodminka + '-do')
            .attr('name', prefix + '[' + indexDefinice + '][skupiny][' + indexSkupina + '][podminky][' + indexPodminka + '][do]')
            .attr('class', 'form-control input-sm text-right hidden')
            .attr('size', 4)
            .attr('onkeydown', onkeydown),

        inputPresne = $(document.createElement("input"))
            .attr('type', 'text')
            .attr('id', prefix + '-' + indexDefinice + '-skupiny-' + indexSkupina + '-podminky-' + indexPodminka + '-presne')
            .attr('name', prefix + '[' + indexDefinice + '][skupiny][' + indexSkupina + '][podminky][' + indexPodminka + '][presne]')
            .attr('class', 'form-control input-sm text-right hidden')
            .attr('size', 4)
            .attr('onkeydown', onkeydown),

        hrefSmazat = '<button class="kombinaceDruhu-podminka-smazat btn btn-xs btn-danger"><i class="fas fa-trash fa-fw"></a>';

    td1.append(selectIdDruh);
    td2.append(selectIdHodnota);
    td3.append(inputOd);
    td4.append(inputDo);
    td5.append(inputPresne);
    td6.append(hrefSmazat);

    tr.append(td1);
    tr.append(td2);
    tr.append(td3);
    tr.append(td4);
    tr.append(td5);
    tr.append(td6);

    $(elSkupina).find('tbody').append(tr);

    return false;
}

function kombinaceDruhuPodminkaSmazat(element) {
    var elTabulka = $(element).parents('table'),
        elTd = $(element).parents('td'),
        elPodminkaId = $(elTd).find(':hidden'),
        prefix = $(element).parents('.kombinaceDruhu-b3').data('prefix');

    if ($(elPodminkaId).length > 0) {
        var el = $.createElement('input')
            .attr('type', 'hidden')
            .attr('name', prefix + '-smazanePodminky[]')
            .val($(elPodminkaId).val());

        $('#' + prefix).append(el);
    }

    $(element).parents('tr').remove();

    kombinaceDruhuPodminkaPreindexovat(elTabulka);
}

function kombinaceDruhuSkupinaPreindexovat(elBox) {
    $(elBox).find('table').each(function(indexSkupina, elTable) {
        indexSkupina++;
        $(elTable).attr('data-skupina', indexSkupina);
        $(elTable).find('input, textarea, select').each(function (b, element) {
            if (element.getAttribute('name') != null) {
                element.name = element.name.replace(/skupiny\]\[(\d+)\]/, 'skupiny][' + indexSkupina + ']');
            }

            if (element.getAttribute('id') != null) {
                element.id = element.id.replace(/-skupiny-(\d+)-/, '-skupiny-' + indexSkupina + '-');
            }
        });
    });
}

function kombinaceDruhuSkupinaPridat(element) {
    var elBox = $(element).parents('.box-body:first'),
        elPridatSkupinuP = $(elBox).find('.kombinaceDruhu-skupina-pridat').parent(),
        elPridatSkupinuPClone = $(elPridatSkupinuP).clone(),
        indexSkupina = $(element).parents('.kombinaceDruhu-definice').find('.kombinaceDruhu-skupina').length + 1,
        prefix = $(element).parents('div.kombinaceDruhu-b3').data('prefix'),

        table = $(document.createElement('table'))
            .attr('class', 'table table-bordered table-striped kombinaceDruhu-skupina')
            .attr('data-skupina', indexSkupina),

        thead = $(document.createElement('thead')),
        theadTr = $(document.createElement('tr')),
        tbody = $(document.createElement('tbody')),
        tfoot = $(document.createElement('tfoot')),
        tfootTr = $(document.createElement('tr')),

        theadThDruh = $(document.createElement('th')).html('Druh').attr('class', 'width-25'),
        theadThHodnota = $(document.createElement('th')).html('Hodnota').attr('class', 'width-40'),
        theadThOd = $(document.createElement('th')).html('Od').attr('class', 'width-10'),
        theadThDo = $(document.createElement('th')).html('Do').attr('class', 'width-10'),
        theadThPresne = $(document.createElement('th')).html('Přesně').attr('class', 'width-10'),
        theadThSmazat = $(document.createElement('th')).attr('class', 'width-5'),
        tfootTdLeva = $(document.createElement('td')).attr('colspan', '2'),
        tfootTdPrava = $(document.createElement('td')).attr('colspan', '4').attr('class', 'text-right'),

        buttonPridatPodminku = $(document.createElement('button'))
            .attr('class', 'kombinaceDruhu-podminka-pridat btn btn-xs btn-primary'),

        buttonPridatPodminkuIcon = $(document.createElement('i'))
            .attr('class', 'fas fa-plus fa-fw'),

        buttonSmazatSkupinu = $(document.createElement('button'))
            .attr('class', 'kombinaceDruhu-skupina-smazat btn btn-xs btn-danger'),

        buttonSmazatSkupinuIcon = $(document.createElement('i'))
            .attr('class', 'fas fa-trash fa-fw');

    theadTr.append(theadThDruh);
    theadTr.append(theadThHodnota);
    theadTr.append(theadThOd);
    theadTr.append(theadThDo);
    theadTr.append(theadThPresne);
    theadTr.append(theadThSmazat);

    thead.append(theadTr);

    buttonPridatPodminku
        .append(buttonPridatPodminkuIcon)
        .append(' Přidat podmínku');
    buttonSmazatSkupinu
        .append(buttonSmazatSkupinuIcon)
        .append(' Smazat skupinu podmínek');

    tfootTdLeva.append(buttonPridatPodminku);
    tfootTdPrava.append(buttonSmazatSkupinu);

    tfootTr.append(tfootTdLeva);
    tfootTr.append(tfootTdPrava);

    tfoot.append(tfootTr);

    table.append(thead);
    table.append(tbody);
    table.append(tfoot);

    $(elPridatSkupinuP).html('nebo').addClass('text-muted');

    $(elBox).append(table);
    $(elBox).append(elPridatSkupinuPClone);

    return false;
}

function kombinaceDruhuSkupinaSmazat(element) {
    var elTd = $(element).parents('td'),
        elTable = $(elTd).parents('table'),
        elBox = $(elTable).parents('.box-body'),
        elSkupinaId = $(elTd).find(':hidden'),
        indexSkupina = $(elTable).data('skupina'),
        prefix = $(element).parents('.kombinaceDruhu-b3').data('prefix');

    if ($(elSkupinaId).length > 0) {
        var el = $.createElement('input')
            .attr('type', 'hidden')
            .attr('name', prefix + '-smazaneSkupiny[]')
            .val($(elSkupinaId).val());

        $('#' + prefix).append(el);
    }

    if (indexSkupina > 1) {
        $(elTable).prev('p').remove();
    }
    if (indexSkupina == 1 && $(elBox).find('.kombinaceDruhu-skupina').length > 1) {
        $(elTable).next('p').remove();
    }

    $(elTable).remove();

    kombinaceDruhuSkupinaPreindexovat(elBox);
}

function kombinaceDruhuDuplikujTabulku(prefix, tableNumber) {
    Lemo_Alert.addInfo('Duplikuji tabulku...', 'duplikaceTabulky');

    // Zduplikujeme tabulku
    $('#' + prefix + '-' + tableNumber + '-blok').clone().appendTo('#' + prefix);

    // Predindexujeme tabulky
    kombinaceDruhuPreindexujTabulky(prefix);

    // Zjistime si cislo duplikovane tabulky
    var newTableNumber = $('#' + prefix).find('table').length;

    $('#' + prefix + '-' + newTableNumber + '-tabulka th').each(function () {
        $(this).attr('style', 'background-color: #e14b4b');
    });

    // Odstranime pole s ID jednotlivych radku (ID z DB)
    $('#' + prefix + '-' + newTableNumber + '-blok').find("input[id$='-id']").each(function () {
        $(this).remove();
    });

    Lemo_Alert.closeById('duplikaceTabulky');

    return false;
}

function kombinaceDruhuDefiniceHlavicka(divBoxHeader, prefix, indexDefinice) {
    var elementBody = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][body]')
            .attr('id', prefix + '-' + indexDefinice + '-body')
            .attr('class', 'form-control'),

        elementBonus = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][bonus]')
            .attr('id', prefix + '-' + indexDefinice + '-bonus')
            .attr('class', 'form-control text-right'),

        elementCastka = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][castka]')
            .attr('id', prefix + '-' + indexDefinice + '-castka')
            .attr('class', 'form-control text-right'),

        elementDruhBonusovaSleva = $(document.createElement('select'))
            .attr('name', prefix + '[' + indexDefinice + '][druh]')
            .attr('id', prefix + '-' + indexDefinice + '-druh')
            .attr('class', 'form-control druhBonusoveSlevy')
            .append('<option value="sleva">Sleva</option>')
            .append('<option value="bonus">Bonus</option>'),

        elementDuvod = $(document.createElement('textarea'))
            .attr('name', prefix + '[' + indexDefinice + '][duvod]')
            .attr('id', prefix + '-' + indexDefinice + '-duvod')
            .attr('class', 'form-control')
            .attr('rows', 2)
            .attr('placeholder', 'Zobrazuje se s prefixem Nelze pojistit:'),

        elementHeslo = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][heslo]')
            .attr('id', prefix + '-' + indexDefinice + '-heslo')
            .attr('class', 'form-control')
            .attr('placeholder', 'V případě vyplnění se bude vyžadovat heslo.'),

        elementIdentifikator = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][identifikator]')
            .attr('id', prefix + '-' + indexDefinice + '-identifikator')
            .attr('class', 'form-control'),

        elementIdentifikatoryNelzeKombinovat = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][identifikatoryNelzeKombinovat]')
            .attr('id', prefix + '-' + indexDefinice + '-identifikatoryNelzeKombinovat')
            .attr('class', 'form-control')
            .attr('placeholder', 'Seznam identifikátorů jiných BS oddělených čárkou'),

        elementKod = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][kod]')
            .attr('id', prefix + '-' + indexDefinice + '-kod')
            .attr('class', 'form-control'),

        elementKoeficient = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][koeficient]')
            .attr('id', prefix + '-' + indexDefinice + '-koeficient')
            .attr('class', 'form-control'),

        elementKrok = $(document.createElement('select'))
            .attr('name', prefix + '[' + indexDefinice + '][krok]')
            .attr('id', prefix + '-' + indexDefinice + '-krok')
            .attr('class', 'form-control text-right'),

        elementMaximumSelect = $(document.createElement('select'))
            .attr('name', prefix + '[' + indexDefinice + '][maximum]')
            .attr('id', prefix + '-' + indexDefinice + '-maximum')
            .attr('class', 'form-control text-right'),

        elementMaximumText = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][maximum]')
            .attr('id', prefix + '-' + indexDefinice + '-maximum')
            .attr('class', 'form-control text-right'),

        elementMinimalniPojistne = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][sazba]')
            .attr('id', prefix + '-' + indexDefinice + '-sazba')
            .attr('class', 'form-control text-right'),

        elementNazev = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][nazev]')
            .attr('id', prefix + '-' + indexDefinice + '-nazev')
            .attr('class', 'form-control'),

        elementNezobrazovat = $(document.createElement('input'))
            .attr('type', 'checkbox')
            .attr('name', prefix + '[' + indexDefinice + '][nezobrazovat]')
            .attr('id', prefix + '-' + indexDefinice + '-nezobrazovat')
            .val(1),

        elementNezobrazovatHidden = $(document.createElement('input'))
            .attr('type', 'hidden')
            .attr('name', prefix + '[' + indexDefinice + '][nezobrazovat]')
            .val(0),

        elementOdkazText = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][odkazText]')
            .attr('id', prefix + '-' + indexDefinice + '-odkazText')
            .attr('class', 'form-control'),

        elementOdkazUrl = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][odkazUrl]')
            .attr('id', prefix + '-' + indexDefinice + '-odkazUrl')
            .attr('class', 'form-control')
            .attr('placeholder', 'https://'),

        elementPopis = $(document.createElement('textarea'))
            .attr('name', prefix + '[' + indexDefinice + '][popis]')
            .attr('id', prefix + '-' + indexDefinice + '-popis')
            .attr('class', 'form-control')
            .attr('rows', 3),

        elementPricist = $(document.createElement('input'))
            .attr('type', 'checkbox')
            .attr('name', prefix + '[' + indexDefinice + '][pricist]')
            .attr('id', prefix + '-' + indexDefinice + '-pricist')
            .val(1),

        elementPricistHidden = $(document.createElement('input'))
            .attr('type', 'hidden')
            .attr('name', prefix + '[' + indexDefinice + '][pricist]')
            .val(0),

        elementProcent = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][procent]')
            .attr('id', prefix + '-' + indexDefinice + '-procent')
            .attr('class', 'form-control text-right'),

        elementPripojisteni = $(document.createElement('select'))
            .attr('name', prefix + '[' + indexDefinice + '][idBalicek]')
            .attr('id', prefix + '-' + indexDefinice + '-idBalicek')
            .attr('class', 'form-control'),

        elementSazba = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][sazba]')
            .attr('id', prefix + '-' + indexDefinice + '-sazba')
            .attr('class', 'form-control text-right'),

        elementSazbaDop = $(document.createElement('select'))
            .attr('name', prefix + '[' + indexDefinice + '][idSazba]')
            .attr('id', prefix + '-' + indexDefinice + '-idSazba')
            .attr('class', 'form-control')
            .attr('disabled', true).prop('disabled', true)
            .append('<option value="">-</option>'),

        elementSkupina = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][skupina]')
            .attr('id', prefix + '-' + indexDefinice + '-skupina')
            .attr('class', 'form-control'),

        elementSleva = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][sleva]')
            .attr('id', prefix + '-' + indexDefinice + '-sleva')
            .attr('class', 'form-control text-right'),

        elementVychoziStav = $(document.createElement('input'))
            .attr('type', 'checkbox')
            .attr('name', prefix + '[' + indexDefinice + '][vychoziStav]')
            .attr('id', prefix + '-' + indexDefinice + '-vychoziStav')
            .val(1),

        elementVychoziStavHidden = $(document.createElement('input'))
            .attr('type', 'hidden')
            .attr('name', prefix + '[' + indexDefinice + '][vychoziStav]')
            .val(0),

// HODNOTY PRO SELECTY

        mesice = [0, 12, 24, 36, 48, 60, 72, 84, 96, 108, 120];
    $.each(mesice, function (i, mesic) {
        elementMaximumSelect.append('<option value="' +  mesic + '">' +  mesic + '</option>');
    });

    for (var i=1; i<=50; i++) {
        elementKrok.append('<option value="' +  i + '">' +  i + '</option>');
    }

    if(prefix === 'nelzePojistitDop') {
        elementPripojisteni.html($('#nelzePojistitDop-data-druhyDoplnkovychPojisteni').html());
    }

// BLOKY

    var divBody = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-body" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-body" class="control-label col-sm-6">Body</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(elementBody).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divBonus = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-bonus" class="form-group form-group-sm hidden">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-bonus" class="control-label col-sm-6">Bonus</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '            ' + $(elementBonus).prop('outerHTML') +
        '            <div class="input-group-addon">m</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divCastka = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-castka" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-castka" class="control-label col-sm-6">Částka</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '            ' + $(elementCastka).prop('outerHTML') +
        '            <div class="input-group-addon">Kč</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divDruhBonusovaSleva = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-druh" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-druh" class="control-label col-sm-6">Druh</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(elementDruhBonusovaSleva).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divDuvod = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-duvod" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-duvod" class="control-label col-sm-6">Důvod</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(elementDuvod).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divHeslo = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-heslo" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-heslo" class="control-label col-sm-6">Heslo</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(elementHeslo).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divIdentifikator = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-identifikator" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-identifikator" class="control-label col-sm-6">Identifikátor</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(elementIdentifikator).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divIdentifikatoryNelzeKombinovat = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-IdentifikatoryNelzeKombinovat" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-IdentifikatoryNelzeKombinovat" class="control-label col-sm-2">Nelze kominovat s BS</label>' +
        '    <div class="col-sm-10">' +
        '      ' + $(elementIdentifikatoryNelzeKombinovat).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divKod = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-kod" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-kod" class="control-label col-sm-6">Kód</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(elementKod).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divKoeficient = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-koeficient" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-koeficient" class="control-label col-sm-6">Koeficient</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(elementKoeficient).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divKrok = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-krok" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-krok" class="control-label col-sm-6">Krok po</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '            ' + $(elementKrok).prop('outerHTML') +
        '            <div class="input-group-addon">%</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divMaximumSelect = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-maximum" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-maximum" class="control-label col-sm-6">Maximální výše</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '      ' + $(elementMaximumSelect).prop('outerHTML') +
        '            <div class="input-group-addon">měsíců</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divMaximumText = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-maximum" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-maximum" class="control-label col-sm-6">Maximální výše</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '            ' + $(elementMaximumText).prop('outerHTML') +
        '            <div class="input-group-addon">m</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divMinimalniPojistne = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-sazba" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-sazba" class="control-label col-sm-6">Minimální pojistné</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '            ' + $(elementMinimalniPojistne).prop('outerHTML') +
        '            <div class="input-group-addon">Kč</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divNazev = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-nazev" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-nazev" class="control-label col-sm-6">Název</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(elementNazev).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divNezobrazovat = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-nezobrazovat" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-nezobrazovat" class="control-label col-sm-6">Nezobrazovat</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(elementNezobrazovatHidden).prop('outerHTML') +
        '      ' + $(elementNezobrazovat).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divOdkazText = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-odkazText" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-odkazText" class="control-label col-sm-6">Odkaz - Text</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(elementOdkazText).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divOdkazUrl = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-odkazUrl" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-odkazUrl" class="control-label col-sm-6">Odkaz - Url</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(elementOdkazUrl).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divPopis = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-popis" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-popis" class="control-label col-sm-6">Popis</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(elementPopis).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divPricist = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-pricist" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-pricist" class="control-label col-sm-6">Přičíst k vlastnímu bonusu</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(elementPricistHidden).prop('outerHTML') +
        '      ' + $(elementPricist).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divPripojisteni = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-idBalicek" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-idBalicek" class="control-label col-sm-6">Připojištění</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(elementPripojisteni).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divProcent = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-procent" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-procent" class="control-label col-sm-6">Procent</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '            ' + $(elementProcent).prop('outerHTML') +
        '            <div class="input-group-addon">%</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divSazba = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-sazba" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-sazba" class="control-label col-sm-6">Sazba</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '            ' + $(elementSazba).prop('outerHTML') +
        '            <div class="input-group-addon">Kč</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divSazbaDop = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-idSazba" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-idSazba" class="control-label col-sm-6">Sazba</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(elementSazbaDop).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divSkupina = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-skupina" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-skupina" class="control-label col-sm-6">Skupina</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(elementSkupina).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divSleva = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-sleva" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-sleva" class="control-label col-sm-6">Sleva</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '            ' + $(elementSleva).prop('outerHTML') +
        '            <div class="input-group-addon">%</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divVychoziStav = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-vychoziStav" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-vychoziStav" class="control-label col-sm-6">Vybráno ve výchozím stavu</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(elementVychoziStavHidden).prop('outerHTML') +
        '      ' + $(elementVychoziStav).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

// SESTAVENI HLAVICKY
    if(prefix === 'bonusoveSlevy') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divNazev).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divIdentifikator).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divPopis).prop('outerHTML') + '</div>' +
            '</div>' +
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divDruhBonusovaSleva).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divSleva).prop('outerHTML') + $(divBonus).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divNezobrazovat).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divVychoziStav).prop('outerHTML') + '</div>' +
            '</div>' +
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divOdkazUrl).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divOdkazText).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divHeslo).prop('outerHTML') + '</div>' +
            '</div>' +
            '<div class="row">' +
            '    <div class="col-sm-12">' + $(divIdentifikatoryNelzeKombinovat).prop('outerHTML') + '</div>' +
            '</div>'
        );
    }
    if(prefix === 'koeficienty') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divKod).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divSkupina).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divKoeficient).prop('outerHTML') + '</div>' +
            '</div>'
        );
    }
    if(prefix === 'jednorazoveSlevy') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divNazev).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divIdentifikator).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divPopis).prop('outerHTML') + '</div>' +
            '</div>' +
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divCastka).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divVychoziStav).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4"></div>' +
            '</div>'
        );
    }
    if(prefix === 'maximalniSlevy') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divProcent).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divKoeficient).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4"></div>' +
            '</div>'
        );
    }
    if(prefix === 'minimalniPojistne') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divMinimalniPojistne).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4"></div>' +
            '    <div class="col-sm-4"></div>' +
            '</div>'
        );
    }
    if(prefix === 'nelzePojistit') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divDuvod).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4"></div>' +
            '    <div class="col-sm-4"></div>' +
            '</div>'
        );
    }
    if(prefix === 'nelzePojistitDop') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divDuvod).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divPripojisteni).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divSazbaDop).prop('outerHTML') + '</div>' +
            '</div>'
        );
    }
    if(prefix === 'prevodBonusu') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4"></div>' +
            '    <div class="col-sm-4"></div>' +
            '    <div class="col-sm-4">' + $(divMaximumSelect).prop('outerHTML') + '</div>' +
            '</div>'
        );
    }
    if(prefix === 'skutecnaVybava') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divBody).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4"></div>' +
            '    <div class="col-sm-4"></div>' +
            '</div>'
        );
    }
    if(prefix === 'skutecneZabezpeceni') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divNazev).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divKod).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divSkupina).prop('outerHTML') + '</div>' +
            '</div>'
        );
    }
    if(prefix === 'slevy') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divNazev).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divMaximumText).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divKrok).prop('outerHTML') + '</div>' +
            '</div>' +
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divIdentifikator).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4"></div>' +
            '    <div class="col-sm-4"></div>' +
            '</div>'
        );
    }
    if(prefix === 'vernostniBonusy') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divNazev).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divMaximumSelect).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divPricist).prop('outerHTML') + '</div>' +
            '</div>'
        );
    }
    if(prefix === 'zabezpeceni') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divNazev).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4"></div>' +
            '    <div class="col-sm-4"></div>' +
            '</div>'
        );
    }
    if(prefix === 'zakladniSazby') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divKod).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divSazba).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4"></div>' +
            '</div>'
        );
    }

    return divBoxHeader;
}

function kombinaceDruhuPreindexujTabulky(prefix) {
    $('#' + prefix).find('div[id$=\'-blok\']').each(function(a, element) {
        a++;

        // Preindexujeme ID bloku
        element.id = element.id.replace(/(\d+)/, a);

        // Preindexujeme ID bloku, tabulky a radku
        $(element).find('div, table, tr').each(function(b, subElement) {
            subElement.id = subElement.id.replace(/-(\d+)-/, '-' + a + '-');
        });


        // Preindexujeme elementy v hlavicce bloku
        $('#' + prefix + '-' + a + '-hlavicka').find('input, select').each(function(b, subElement)
        {
            if(subElement.getAttribute('id') != null) {
                subElement.id = subElement.id.replace(/(\d+)/, a);
            }

            if(subElement.getAttribute('name') != null) {
                subElement.name = subElement.name.replace(/(\d+)/, a);
            }
        });

        // Preindexujeme elementy uvnitr tabulky
        $('#' + prefix + '-' + a + '-tabulka').find('a, input, select, textarea').each(function(b, subElement)
        {
            if(subElement.getAttribute('id') != null) {
                subElement.id = subElement.id.replace(/-(\d+)-podminky-(\d+)-/, '-' + a + '-podminky-$2-');
            }

            if(subElement.getAttribute('name') != null) {
                subElement.name = subElement.name.replace(/\[(\d+)\]\[podminky\]\[(\d+)\]/, '[' + a + '][podminky][$2]');
            }

            if(subElement.getAttribute('for') != null) {
                subElement.setAttribute('for', subElement.getAttribute('for').replace(/-(\d+)-podminky-(\d+)-/, '-' + a + '-podminky-$2-'));
            }

            if(subElement.getAttribute('onclick') != null) {
                subElement.setAttribute('onclick', subElement.getAttribute('onclick').replace(/(\d+),/, a + ','));
            }
        });
    });
}

$(document).ready(function() {
    var kombinaceDruhu = $('.kombinaceDruhu-b3');

    kombinaceDruhu.on('change', '.idDruh', function () {
        var id = $(this).attr('id').replace('idDruh', 'idHodnota');
        var value = $(this).val();

        kombinaceDruhuPodminkaNactiHodnoty(id, value);
    });

    $('.kombinaceDruhu-definice-pridat').on('click', function () {
        kombinaceDruhuDefinicePridat(this);

        return false;
    });

    kombinaceDruhu.on('click', '.kombinaceDruhu-definice-duplikovat', function (e) {
        e.preventDefault();
        kombinaceDruhuDefiniceDuplikovat(this);

        return false;
    });

    kombinaceDruhu.on('click', '.kombinaceDruhu-definice-smazat', function () {
        kombinaceDruhuDefiniceSmazat(this);

        return false;
    });

    kombinaceDruhu.on('click', '.kombinaceDruhu-podminka-pridat', function () {
        kombinaceDruhuPodminkaPridat(this);

        return false;
    });

    kombinaceDruhu.on('click', '.kombinaceDruhu-podminka-smazat', function () {
        kombinaceDruhuPodminkaSmazat(this);

        return false;
    });

    kombinaceDruhu.on('click', '.kombinaceDruhu-skupina-pridat', function () {
        kombinaceDruhuSkupinaPridat(this);

        return false;
    });

    kombinaceDruhu.on('click', '.kombinaceDruhu-skupina-smazat', function () {
        kombinaceDruhuSkupinaSmazat(this);

        return false;
    });

    $('#bonusoveSlevy').on('change', '.druhBonusoveSlevy', function() {
        var number = this.getAttribute('id').match(/(\d+)/g);

        if(this.value === 'sleva') {
            $('#bonusoveSlevy-' + number[0] + '-hlavicka-sleva').removeClass('hidden');
            $('#bonusoveSlevy-' + number[0] + '-hlavicka-bonus').addClass('hidden');
            $('#bonusoveSlevy-' + number[0] + '-bonus').val('');
        } else {
            $('#bonusoveSlevy-' + number[0] + '-hlavicka-bonus').removeClass('hidden');
            $('#bonusoveSlevy-' + number[0] + '-hlavicka-sleva').addClass('hidden');
            $('#bonusoveSlevy-' + number[0] + '-sleva').val('');
        }
    });
});
